import axios from 'axios';

import { isProductionPortalHost } from '../../../../helpers/portalHost';

// Same APIs the marketplace-integrations MFE uses for its tables
const marketplaceIntegrationsApi = axios.create({
  baseURL: isProductionPortalHost()
    ? 'https://api.portal.flipdish.com/marketplace-integrations/core'
    : 'https://marketplace-integrations-integration.portal.flipdishdev.com',
  withCredentials: true,
});

export type IntegratedStore = {
  marketplace: string;
  marketplaceStoreId: string;
  marketplaceStoreName: string;
  brandId: string;
  propertyId: string;
  salesChannelId: string;
  menuId: string;
  priceBandId: string;
  enabledAt: string | null;
  openingHours?: unknown[];
  holidayHoursUntil?: string | null;
  storeUrl?: string;
};

export type MarketplaceProperty = {
  propertyId: string;
  name: string;
  address: string;
};

export type UberEatsStore = {
  marketplaceStoreId: string;
  accessTokenExpired: boolean | null;
  marketplaceStoreDetails?: unknown;
};

const get = async <T>(url: string): Promise<T> => {
  const { data } = await marketplaceIntegrationsApi.get<T>(url);
  return data;
};

export const getIntegratedStores = (orgId: string) =>
  get<IntegratedStore[]>(`/orgs/${orgId}/integrated-stores`);

export const getMarketplaceProperties = (orgId: string) =>
  get<MarketplaceProperty[]>(`/orgs/${orgId}/properties`);

export const getUberEatsStores = async (orgId: string) => {
  const stores = await get<UberEatsStore[]>(`/orgs/${orgId}/uber-eats/stores`);
  return stores.filter((store) => !!store.marketplaceStoreDetails);
};
